import { CanvasObject } from "./object.js";

class ImageObject extends CanvasObject {
    constructor({
        context,
        saveState = null
    }) {
        super(context);
        this.name = "Image Object";
        this.image = (saveState && saveState.image) ? saveState.image : null;
        this._img = null;
        this.fill = { // we need to merge image into this fill
            enabled: true,
            color: '#000000'
        };
        
        this.position = (saveState && saveState.position) ? {...saveState.position} : this.position;
        // this.dimensions = (saveState && saveState.dimensions) ? {...saveState.dimensions} : this.dimensions;

        if (this.image) {
            this._img = new Image();
            this._img.onload = () => {
                if (!this.dimensions.width || !this.dimensions.height) {
                    this.setDimensions({ w: this._img.width, h: this._img.height });
                }
            };
            this._img.src = this.image;
        }

        this._init();
    }
    _init() {
        if (!this.image) {
            const uploadImageElement = document.createElement('input');
            uploadImageElement.type = 'file';
            uploadImageElement.accept = 'image/*';

            uploadImageElement.onchange = (e) => {
                const file = e.target.files[0];
                if (!file) return;

                const reader = new FileReader();
                reader.onload = (event) => {
                    const dataUrl = event.target.result; // base64 string
                    this.image = dataUrl;

                    // Optionally set dimensions from the real image
                    const img = new Image();
                    img.onload = () => {
                        this.setDimensions({ w: img.width, h: img.height });
                    };
                    img.src = dataUrl;

                    // Let the rest of the app know this object changed so it can re‑save
                    this.context.canvas.dispatchEvent(new CustomEvent('creator:object:update', {
                        detail: { context: this.context, object: this }
                    }));
                };
                reader.readAsDataURL(file);
            };

            uploadImageElement.click();
        }
    }
    _getObjectBoundingRect() {
        const bounds = {
            ...this.position,
            ...this.dimensions
        }
        this.boundingRect = bounds;

        return bounds;
    }
    isCursorOnObject({x, y} = {}) {
        return this._cursorInBounds({x, y});
    }
    startDragObject({controls} = {}) {
        this.dragging = true;

        this.position.before = {
            ...this.position
        }

        controls.mouse.before = {
            x: controls.mouse.x,
            y: controls.mouse.y
        }
    }
    moveTo({x, y, before}) {
        this.position = {
            x: this.position.before.x + x,
            y: this.position.before.y + y,
            before: this.position.before
        };

        this._getObjectBoundingRect();
    }
    resize({position, dimensions, cursor}) {
        const leftEdge = this.resize_boundary.type === 'edge' && this.resize_boundary.name === 'left';
        const rightEdge = this.resize_boundary.type === 'edge' && this.resize_boundary.name === 'right';
        const topEdge = this.resize_boundary.type === 'edge' && this.resize_boundary.name === 'top';
        const bottomEdge = this.resize_boundary.type === 'edge' && this.resize_boundary.name === 'bottom';

        const bottomLeftCorner = this.resize_boundary.type === 'bottom.corner' && this.resize_boundary.name === 'left';
        const bottomRightCorner = this.resize_boundary.type === 'bottom.corner' && this.resize_boundary.name === 'right';
        const topLeftCorner = this.resize_boundary.type === 'top.corner' && this.resize_boundary.name === 'left';
        const topRightCorner = this.resize_boundary.type === 'top.corner' && this.resize_boundary.name === 'right';

        // resizing logic for frame object
        if( rightEdge ) this.dimensions.width = this.dimensions.before.width + cursor.x;
        else if( leftEdge ) {
            this.position.x = this.position.before.x + cursor.x;
            this.dimensions.width = this.dimensions.before.width - cursor.x;
        }
        else if( topEdge ) {
            this.position.y = this.position.before.y + cursor.y;
            this.dimensions.height = this.dimensions.before.height - cursor.y;
        }
        else if( bottomEdge ) this.dimensions.height = this.dimensions.before.height + cursor.y;
        else if( topRightCorner ) {
            this.position.y = this.position.before.y + cursor.y;
            this.dimensions.width = this.dimensions.before.width + cursor.x;
            this.dimensions.height = this.dimensions.before.height - cursor.y;
        }
        else if( topLeftCorner ) {
            this.position.x = this.position.before.x + cursor.x;
            this.position.y = this.position.before.y + cursor.y;
            this.dimensions.width = this.dimensions.before.width - cursor.x;
            this.dimensions.height = this.dimensions.before.height - cursor.y;
        }
        else if( bottomRightCorner ) {
            this.dimensions.width = this.dimensions.before.width + cursor.x;
            this.dimensions.height = this.dimensions.before.height + cursor.y;
        }
        else if( bottomLeftCorner ) {
            this.position.x = this.position.before.x + cursor.x;
            this.dimensions.width = this.dimensions.before.width - cursor.x;
            this.dimensions.height = this.dimensions.before.height + cursor.y;
        }

        this._getObjectBoundingRect();
    }
    startResizeObject({controls, resize_boundary} = {}) {
        this.resizing = true;
        this.resize_boundary = resize_boundary;

        this.dimensions.before = {
            width: this.dimensions.width,
            height: this.dimensions.height
        }

        this.position.before = {
            x: this.position.x,
            y: this.position.y
        }

        controls.mouse.before = {
            x: controls.mouse.x,
            y: controls.mouse.y
        }
    }
    setDimensions({w, h}) {
        this.dimensions.width = w;
        this.dimensions.height = h;

        // creator:object:update
        this.context.canvas.dispatchEvent(new CustomEvent('creator:object:update', {
            detail: {
                context: this.context,
                object: this
            }
        }));
    }
    setPosition({x, y}) {
        this.position.x = x;
        this.position.y = y;

        this._getObjectBoundingRect();

        // creator:object:update
        this.context.canvas.dispatchEvent(new CustomEvent('creator:object:update', {
            detail: {
                context: this.context,
                object: this
            }
        }));
    }
    render() {
        const ctx = this.context;

        if (this.image && !this._img) {
            this._img = new Image();
            this._img.onload = () => {
                if (!this.dimensions.width || !this.dimensions.height) {
                    this.setDimensions({ w: this._img.width, h: this._img.height });
                }
            };
            this._img.src = this.image;
        }

        if (this._img) {
            ctx.drawImage(
                this._img,
                this.position.x,
                this.position.y,
                this.dimensions.width,
                this.dimensions.height
            );
        } else {
            ctx.fillStyle = 'white';
            ctx.beginPath();
            ctx.rect(
                this.position.x,
                this.position.y,
                this.dimensions.width, 
                this.dimensions.height
            );
            ctx.fill();
        }

        if(this.selected && !this.editing) this.showSelected();
        if(this.hovered) this.showHover();
    }
    getState() {
        return {
            type: "ImageObject",
            position: { ...this.position },
            dimensions: { ...this.dimensions },
            image: this.image,
            fill: { ...this.fill }
        }
    }
}

export {
    ImageObject
}
